import {defineStore} from 'pinia';
import {usePage} from '@inertiajs/vue3';
import {router} from '@inertiajs/vue3';
import route from 'ziggy-js';
import {VisitOptions} from '@inertiajs/core';

interface State {
    history: string[]
}

export const useHistoryStore = defineStore('history', {
    state: (): State => ({
        history: []
    }),
    getters: {
        lastURL(): string | undefined {
            return this.history.length > 0 ? this.history[this.history.length - 1] : undefined;
        }
    },
    actions: {
        push(route: string) {
            if (this.lastURL?.includes('/draft-papers/view') && route.includes('/papers/view')) {
                return; // TODO Find a better way to exclude 404 pages from history
            }

            if (route !== this.lastURL) {
                this.history.push(route);
            }

            if (this.history.length > 10) {
                this.history.shift();
            }
        },
        replace(route: string) {
            this.history.pop();
            this.history.push(route);
        },
        pop(): string | undefined {
            this.history.pop();
            const last = this.lastURL;
            return last?.endsWith('/create') ? this.pop() : last;
        },
        back(visitOptions?: VisitOptions) {
            const user = usePage().props.auth.user;
            const prev = this.pop() || (user != null ? route('dashboard') : route('landing'));
            router.visit(prev, visitOptions);
        }
    }
})
